import { Blockquote, Inset, Text } from "@radix-ui/themes";
import AddBottomSpace from "../../components/AddBottomSpace";
import AddHeadline from "../../components/AddHeadline";
import AddTopSpace from "../../components/AddTopSpace";

export default function Philosophy() {

  return (
    <>
      <AddTopSpace />
      <AddHeadline />
      <div className="container">

        <div className='row'>
          <div className='col-lg-4'>
            <div className="container py-3">
              <div className='row'>
                <div className='col'>
                  <Blockquote size="8" color>
                    Philosophy
                  </Blockquote>
                </div>
              </div>

              <div className='row py-3'>
                <div className='col'>
                  <Inset clip="padding-box" side="top" pb="current">
                    <img
                      src="https://www.shadvala.org/img/interstices-philosophy.jpg"
                      alt="Philosophy"
                      style={{
                        display: 'block',
                        objectFit: 'cover',
                        width: '40%',
                        height: '40%',
                        backgroundColor: 'var(--gray-5)',
                      }}
                    />
                  </Inset>
                </div>
              </div>

            </div>
          </div>
          
          <div className='col-lg-8'>
            <div className="container py-3">
              <div className='row'>
                <div className='col'>
                  <Text as="p" mb="5" size="4">
                    Interstices emphasizes local nuances against abstract universalism, experience-centered approaches against impersonal knowledge, creative thinking against rigid specialization, subjective engagement against objective detachment, exploration against domination, life-affirming eroticism against life-denying asceticism, the search for wisdom against the reproduction of ignorance, the good use of imagination against the bad use of reason, constructive criticism against destructive antagonism, energetic against exegetic readings, a politics of hospitality against xenophobic obsessions, ecstatic religiosity against dogmatic beliefs, poetry against reified language, community against individualism, relation against isolation. 
                  </Text>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='row'>
          <div className='col-lg-4'>
            <div className="container py-3">
              <div className='row pb-1'>
                <div className='col'>
                  <Blockquote size="6" color>
                    Endeavor
                  </Blockquote>
                </div>
              </div>
            </div>
          </div>
          
          <div className='col-lg-8'>
            <div className="container py-3">
              <div className='row pb-3'>
                <div className='col'>
                  <Text as="p" mb="5" size="4">
                    The central aim of the Center Interstices is to decompose the dominant way of composing our world. To compose a world is our main way of existentially engaging ourselves, individually and collectively, in living networks of humans and non-humans around us. 
                  </Text>
                </div>
              </div>
              <div className='row pb-3'>
                <div className='col'>
                  <Text as="p" mb="5" size="4">
                    From the beginnings of modernity, Western civilization has composed a world in which non-humans (plants, animals, rivers, forests, etc.) are objectified, that is, deprived of all subjective quality and transformed into an assemblage of resources to be exploited for the benefit of humans. The focus on science and technology at the service of a total mercantilization of reality has become a criterion of global politics. The result of that course of action has been an exponential destruction of bio-diversity, a progressive elimination of creative and critical thinking, a naturalization of human alienation, and a reduction of complex and interrelated living beings to quantifiable and merely instrumental atoms. 
                  </Text>
                </div>
              </div>
              <div className='row pb-3'>
                <div className='col'>
                  <Text as="p" mb="5" size="4">
                    Decomposing the dominant way of composing our world does not mean rejecting the present world configuration as a whole – something which is historically and existentially impossible. It implies a constant effort to know other world configurations, to learn from them, and to work constructively on an effective change in levels of perception, imagination and cognition to restitute a network of relations in which humans may co-create a world with (and not at the expense of) all other beings.
                  </Text>
                </div>
              </div>
            </div>
          </div>
        </div>


      </div>
      
      <AddBottomSpace />
    </>
  )
}
